import { GPTGameModal as Modal } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { useModalContext } from 'src/hooks/useModalContext';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';

export default function GPTGameModal() {
  const { openModal } = useModalContext();
  const { startRegistration } = useAuthFlow();
  return (
    <Modal
      onDeposit={({ promocode }) => openModal('DEPOSIT', { replace: true, props: { promocode } })}
      onRegistration={({ promocode }) =>
        startRegistration({
          replace: true,
          onSuccess: () => openModal('DEPOSIT', { replace: true, props: { promocode } })
        })
      }
    />
  );
}
